/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* FILTER ICON — THE PERIOD, THE OPERATORS AND THE GAMES OF THE LIST */
export const FilterIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 6h18M6.5 12h11M10 18h4" />
    </Icon>
)

/* CHAT ICON — THE SECTION ITSELF */
export const ChatIcon = ({ size = 20 }) => (
    <Icon size={size}>
        <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H9.5L5 20v-4H4Z" />
        <path d="M8.5 8h7M8.5 11.5h4" />
    </Icon>
)

/* COPY ICON — THE TEXT OF A MESSAGE GOES TO THE CLIPBOARD */
export const CopyIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="9" y="9" width="11" height="11" rx="2.5" />
        <path d="M15 5.5A2.5 2.5 0 0 0 12.5 3H6.5A2.5 2.5 0 0 0 4 5.5v6A2.5 2.5 0 0 0 6.5 14" />
    </Icon>
)

/* PLAYER ICON — WHO WROTE THE MESSAGE */
export const PlayerIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="9" cy="8" r="3.6" />
        <path d="M2.8 19.5c0-3.2 2.8-5.2 6.2-5.2s6.2 2 6.2 5.2" />
        <path d="M16.5 5.2a3.4 3.4 0 0 1 0 6.6M18 14.7c2.1.6 3.4 2.2 3.4 4.3" />
    </Icon>
)

/* VIP ICON — A CROWN, THE PLAYER IS MARKED IN Users */
export const VipIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3 7.5 6.5 11 12 4.5 17.5 11 21 7.5v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
    </Icon>
)

/* DEALER ICON — WHO STOOD AT THE TABLE */
export const DealerIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="7.5" r="3.8" />
        <path d="M4.5 20.5c0-3.7 3.4-6 7.5-6s7.5 2.3 7.5 6" />
    </Icon>
)

/* TABLE ICON — THE GAME BEHIND A MESSAGE */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)

/* STUDIO ICON — THE GROUP OF A GAME */
export const StudioIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="12.5" rx="2.5" />
        <path d="M7 21h10M12 17v4" />
    </Icon>
)

/* OPERATOR ICON — THE ACCOUNT OF THE PLAYER */
export const OperatorIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 20.5V6.5A2 2 0 0 1 6 4.5h6a2 2 0 0 1 2 2v14" />
        <path d="M14 10.5h4a2 2 0 0 1 2 2v8" />
        <path d="M2.5 20.5h19M7.5 8.5h3M7.5 12.5h3M7.5 16.5h3" />
    </Icon>
)

/* CALENDAR ICON — THE PERIOD OF THE LIST */
export const CalendarIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3.5" y="5" width="17" height="15.5" rx="3" />
        <path d="M3.5 10h17M8.5 3v4M15.5 3v4" />
    </Icon>
)

/* CLOCK ICON — THE MOMENT OF THE LAST MESSAGE */
export const ClockIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3.5 2" />
    </Icon>
)

/* INFO ICON — THE HINT OF A SECTION */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 7.6v.6" />
    </Icon>
)

/* HASH ICON — THE NUMBER OF A GAME */
export const HashIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M9.5 3.5 7.5 20.5M16.5 3.5l-2 17M4 8.5h16M3 15.5h16" />
    </Icon>
)

/* LAYERS ICON — HOW MANY ROWS THE FILTER HOLDS */
export const LayersIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3 21 8l-9 5-9-5Z" />
        <path d="M3 13.5l9 5 9-5" />
    </Icon>
)

/* SHIELD ICON — THE CENSOR ITSELF */
export const ShieldIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <path d="M12 3 4.5 6v6c0 4.4 3.1 7.9 7.5 9.5 4.4-1.6 7.5-5.1 7.5-9.5V6Z" />
        <path d="M9 12h6" />
    </Icon>
)

/* BOOK ICON — THE DICTIONARY OF FORBIDDEN WORDS */
export const BookIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H19v15H6.5A2.5 2.5 0 0 0 4 20.5Z" />
        <path d="M8 7.5h7M8 11h5" />
    </Icon>
)

/* PLUS ICON — A NEW WORD OF THE DICTIONARY */
export const PlusIcon = ({ size = 15 }) => (
    <Icon size={size} width={2.6}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
)

/* EDIT ICON — CHANGE A WORD OF THE DICTIONARY */
export const EditIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <path d="M4 20h4L20 8l-4-4L4 16Z" />
        <path d="M14.5 5.5 18.5 9.5" />
    </Icon>
)

/* TRASH ICON — REMOVE A WORD FROM THE DICTIONARY */
export const TrashIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13" />
        <path d="M10.5 11v5.5M13.5 11v5.5" />
    </Icon>
)

/* POWER ICON — A WORD IS SWITCHED OFF INSTEAD OF BEING DELETED */
export const PowerIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <path d="M12 3.5v7" />
        <path d="M7 6.5a7 7 0 1 0 10 0" />
    </Icon>
)

/* ADMIN ICON — WHO HAS BROUGHT THE WORD INTO THE DICTIONARY */
export const AdminIcon = ({ size = 12 }) => (
    <Icon size={size}>
        <circle cx="12" cy="8" r="3.6" />
        <path d="M5 20c0-3.4 3.1-5.6 7-5.6s7 2.2 7 5.6" />
    </Icon>
)
